var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 358.153,
    height: 324.212,
    viewBox: "0 0 358.153 324.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_analytics_re_dkf8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15516",
    "data-name": "Path 15516",
    d: "M583.731,226.424H463.952a7.764,7.764,0,0,1-7.755-7.755V124.593a5.688,5.688,0,0,1,5.681-5.682H585.706a5.786,5.786,0,0,1,5.78,5.78v93.978a7.764,7.764,0,0,1-7.755,7.755Z",
    transform: "translate(-344.71 -112.423)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15517",
    "data-name": "Path 15517",
    d: "M480.217,232.817H584.955a7.52,7.52,0,0,0,7.52-7.52v-72.17a7.52,7.52,0,0,0-7.52-7.52H480.217a7.52,7.52,0,0,0-7.52,7.52V225.3A7.52,7.52,0,0,0,480.217,232.817Z",
    transform: "translate(-353.455 -126.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15518",
    "data-name": "Path 15518",
    d: "M591.255,116.834H455.965v-3.948a7.79,7.79,0,0,1,7.783-7.779H583.471a7.79,7.79,0,0,1,7.784,7.779Z",
    transform: "translate(-344.587 -105.106)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_803",
    "data-name": "Ellipse 803",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    transform: "translate(123.51 3.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_804",
    "data-name": "Ellipse 804",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    transform: "translate(131.152 3.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_805",
    "data-name": "Ellipse 805",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    transform: "translate(138.794 3.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15519",
    "data-name": "Path 15519",
    d: "M498.05,209.321h-5.187a1.062,1.062,0,0,1-1.061-1.061v-5.187a1.062,1.062,0,0,1,1.061-1.061h5.187a1.062,1.062,0,0,1,1.061,1.061v5.187A1.062,1.062,0,0,1,498.05,209.321Z",
    transform: "translate(-363.58 -156.464)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15520",
    "data-name": "Path 15520",
    d: "M498.05,237.914h-5.187a1.062,1.062,0,0,1-1.061-1.061v-5.187a1.062,1.062,0,0,1,1.061-1.061h5.187a1.062,1.062,0,0,1,1.061,1.061v5.187A1.062,1.062,0,0,1,498.05,237.914Z",
    transform: "translate(-363.58 -171.618)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15521",
    "data-name": "Path 15521",
    d: "M498.05,266.507h-5.187a1.062,1.062,0,0,1-1.061-1.061v-5.187a1.062,1.062,0,0,1,1.061-1.061h5.187a1.062,1.062,0,0,1,1.061,1.061v5.187A1.062,1.062,0,0,1,498.05,266.507Z",
    transform: "translate(-363.58 -186.772)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15522",
    "data-name": "Path 15522",
    d: "M547.953,209.651H522.961a1.061,1.061,0,1,1,0-2.122h24.992a1.061,1.061,0,0,1,0,2.122Z",
    transform: "translate(-379.532 -159.389)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15523",
    "data-name": "Path 15523",
    d: "M547.953,238.245H522.961a1.061,1.061,0,1,1,0-2.122h24.992a1.061,1.061,0,0,1,0,2.122Z",
    transform: "translate(-379.532 -174.543)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15524",
    "data-name": "Path 15524",
    d: "M547.953,266.838H522.961a1.061,1.061,0,1,1,0-2.122h24.992a1.061,1.061,0,0,1,0,2.122Z",
    transform: "translate(-379.532 -189.697)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15525",
    "data-name": "Path 15525",
    d: "M683.311,212.5c.027-.446.042-.9.042-1.348a22.24,22.24,0,0,0-22.24-22.24V212.5Z",
    transform: "translate(-453.312 -149.521)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15526",
    "data-name": "Path 15526",
    d: "M632.449,216.8V193.213a22.24,22.24,0,1,0,22.2,23.588Z",
    transform: "translate(-426.334 -151.801)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15527",
    "data-name": "Path 15527",
    d: "M576.683,793.834H219.47a.47.47,0,1,1,0-.94H576.683a.47.47,0,1,1,0,.94Z",
    transform: "translate(-219 -469.622)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528",
    "data-name": "Path 15528",
    d: "M713.5,515.761a5.034,5.034,0,0,1,.418.673l23.554,2.649,3.426-4.628,7.661,4.257-6.743,11.243-28.857-7.573a5.016,5.016,0,1,1,.542-6.619Z",
    transform: "translate(-476.29 -321.679)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15529",
    "data-name": "Path 15529",
    d: "M441.354,494.419a4.726,4.726,0,0,1-6.827-2.433l-16.792.35,4.652-7.385,15.233.8a4.752,4.752,0,0,1,3.734,8.668Z",
    transform: "translate(-324.326 -306.418)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15530",
    "data-name": "Path 15530",
    d: "M379.133,478.848a2.119,2.119,0,0,1-2.081,1.51l-30.733-.781-27.828-8.239a6.025,6.025,0,1,1,3.588-11.5l25.141,8.244,30.176,2.912a2.126,2.126,0,0,1,1.912,2.141l-.087,5.147a2.127,2.127,0,0,1-.086.568Z",
    transform: "translate(-269.485 -292.961)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15531",
    "data-name": "Path 15531",
    d: "M138.46,651.539h5.762l2.742-22.226h-8.5Z",
    transform: "translate(-73.381 -333.524)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15532",
    "data-name": "Path 15532",
    d: "M354.333,777.7h11.348a7.232,7.232,0,0,1,7.232,7.232v.235h-18.58Z",
    transform: "translate(-290.724 -461.571)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15533",
    "data-name": "Path 15533",
    d: "M102.46,651.539h5.762l2.742-22.226h-8.5Z",
    transform: "translate(-54.301 -333.524)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15534",
    "data-name": "Path 15534",
    d: "M318.333,777.7h11.348a7.232,7.232,0,0,1,7.232,7.232v.235h-18.58Z",
    transform: "translate(-271.645 -461.571)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15535",
    "data-name": "Path 15535",
    d: "M313.233,581.589l1.376,81.639a1.88,1.88,0,0,0,2.05,1.841l6.743-.613a1.88,1.88,0,0,0,1.7-1.727l3.948-50.924a.47.47,0,0,1,.938.019l1.973,52.09a1.88,1.88,0,0,0,1.879,1.809h7.232a1.88,1.88,0,0,0,1.877-1.765l5.062-82.838-30.081-7.52Z",
    transform: "translate(-268.942 -353.399)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_806",
    "data-name": "Ellipse 806",
    cx: 11.544,
    cy: 11.544,
    r: 11.544,
    transform: "translate(54.566 128.444)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15536",
    "data-name": "Path 15536",
    d: "M345.343,511.222h-.034l-26.994-.415a2.115,2.115,0,0,1-2.072-1.9l-.306-3.056a.235.235,0,0,0-.468,0L315.155,509a2.112,2.112,0,0,1-1.942,1.9l-1.908.147A2.115,2.115,0,0,1,309.1,508.4l1.643-6.263a85.327,85.327,0,0,0,.8-39.792l-.816-3.713a13.409,13.409,0,0,1,6.331-14.484l5.3-3.108,2.406-3.608a5.21,5.21,0,0,1,4.22-2.314c3.356-.073,9.112.541,10.193,5.448a13.4,13.4,0,0,1,9.063,12.9l-.779,55.67a2.116,2.116,0,0,1-2.114,2.086Z",
    transform: "translate(-266.713 -280.005)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537",
    "data-name": "Path 15537",
    d: "M344.3,394.87c-.047,1.632-1.18,2.576-2.571,3.431a14.876,14.876,0,0,1-4.61,1.583,1.409,1.409,0,0,1-2.07-1.234l-1.461-5.557a35.174,35.174,0,0,1-1.125-5.423c-.352-3.529.485-7.326,2.948-9.878s6.736-3.458,9.688-1.492c3.5-4.474,19.517,5.411,15.567,8.523-.7.554-1.777-.147-2.669-.215a2.848,2.848,0,0,0-2.458.781c-.74.9-.418,2.252-.723,3.38a3.156,3.156,0,0,1-3.987,2.044,10.852,10.852,0,0,1-2.068-1.329,2.66,2.66,0,0,0-2.319-.505c-1.015.379-1.376,1.622-1.468,2.7a25.023,25.023,0,0,1-.673,3.19Z",
    transform: "translate(-279.092 -248.228)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15538",
    "data-name": "Path 15538",
    d: "M141.289,377.819l1.88,23.031,9.87,23.971-14.571-23.5Z",
    transform: "translate(-73.386 -200.237)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15539",
    "data-name": "Path 15539",
    d: "M501.382,575.991,398.368,514.876a7.764,7.764,0,0,1-2.713-10.627l48-80.909a5.688,5.688,0,0,1,7.785-1.988l106.5,63.181a5.786,5.786,0,0,1,2.022,7.92l-47.95,80.824A7.764,7.764,0,0,1,501.382,575.991Z",
    transform: "translate(-312.05 -272.291)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15540",
    "data-name": "Path 15540",
    d: "M420.673,529.437l90.078,53.441a7.52,7.52,0,0,0,10.3-2.631l36.823-62.069a7.52,7.52,0,0,0-2.631-10.3l-90.079-53.44a7.52,7.52,0,0,0-10.3,2.631l-36.823,62.069A7.52,7.52,0,0,0,420.673,529.437Z",
    transform: "translate(-323.931 -289.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15541",
    "data-name": "Path 15541",
    d: "M615.638,486.455,499.284,417.426l2.015-3.4a7.79,7.79,0,0,1,10.663-2.719L614.928,472.4a7.79,7.79,0,0,1,2.725,10.661Z",
    transform: "translate(-367.546 -266.813)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_807",
    "data-name": "Ellipse 807",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    transform: "translate(144.877 150.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_808",
    "data-name": "Ellipse 808",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    transform: "translate(151.449 154.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_809",
    "data-name": "Ellipse 809",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    transform: "translate(158.021 158.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3019",
    "data-name": "Rectangle 3019",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 222.073, 231.645)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15542",
    "data-name": "Path 15542",
    d: "M592.266,538.844l-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.175-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.175-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.175-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.175-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.175-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587Zm-5.351-3.174-2.675-1.587.131-.221,2.675,1.587ZM512,491.226l-2.675-1.587.131-.221,2.675,1.587Z",
    transform: "translate(-372.869 -308.785)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3020",
    "data-name": "Rectangle 3020",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 132.46, 178.48)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3021",
    "data-name": "Rectangle 3021",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 166.413, 226.375)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15543",
    "data-name": "Path 15543",
    d: "M522.869,556.718l-2.636-1.564.131-.221L523,556.5ZM517.6,553.59l-2.636-1.564.131-.221,2.636,1.564Zm-5.272-3.127L509.69,548.9l.131-.221,2.636,1.564Zm-5.271-3.127-2.636-1.564.131-.221,2.636,1.564Zm-5.271-3.127-2.636-1.564.131-.221,2.636,1.564Zm-5.271-3.127-2.636-1.564.131-.221,2.636,1.564Zm-5.271-3.127L488.6,536.39l.131-.221,2.636,1.564Zm-5.271-3.127-2.636-1.564.131-.221,2.636,1.564Z",
    transform: "translate(-359.092 -331.905)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3022",
    "data-name": "Rectangle 3022",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 120.281, 199.007)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3023",
    "data-name": "Rectangle 3023",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 134.826, 220.767)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15544",
    "data-name": "Path 15544",
    d: "M484.794,562.065l-2.712-1.609.131-.221,2.712,1.609Zm-5.424-3.218-2.712-1.609.131-.221,2.712,1.609Zm-5.424-3.218-2.712-1.609.131-.221,2.712,1.609Z",
    transform: "translate(-352.681 -342.906)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3024",
    "data-name": "Rectangle 3024",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 114.52, 208.719)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3025",
    "data-name": "Rectangle 3025",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 124.994, 237.34)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15545",
    "data-name": "Path 15545",
    d: "M463.875,597.327l-2.712-1.609.131-.221,2.712,1.609Zm-5.424-3.218L455.74,592.5l.131-.221,2.712,1.609Zm-5.423-3.218-2.712-1.609.131-.221,2.712,1.609Z",
    transform: "translate(-341.594 -361.594)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3026",
    "data-name": "Rectangle 3026",
    width: 0.257,
    height: 1.54,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 104.687, 225.293)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15546",
    "data-name": "Path 15546",
    d: "M457.4,587.948l76.336,45.287a8.115,8.115,0,0,0,11.107-2.836l22.3-37.595L567,592.72l-50.6,12.917-4.009-15.7a1.938,1.938,0,0,0-1.122-1.31,2.066,2.066,0,0,0-1.324-.074l-26.519,6.768-2.931-11.475a1.946,1.946,0,0,0-2.367-1.4C477.938,582.493,460.682,587.065,457.4,587.948Z",
    transform: "translate(-345.349 -358.055)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15547",
    "data-name": "Path 15547",
    d: "M456.359,587.816l-.063-.249,21.221-5.417a2.184,2.184,0,0,1,2.653,1.574l2.872,11.25,26.372-6.732a2.184,2.184,0,0,1,2.653,1.574l3.949,15.47L566.884,592.3l.063.249L515.831,605.6l-4.013-15.719a1.925,1.925,0,0,0-2.341-1.389l-26.62,6.8-2.935-11.5a1.927,1.927,0,0,0-2.341-1.389Z",
    transform: "translate(-344.763 -357.895)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_810",
    "data-name": "Ellipse 810",
    cx: 1.797,
    cy: 1.797,
    r: 1.797,
    transform: "translate(134.419 219.647)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_811",
    "data-name": "Ellipse 811",
    cx: 1.797,
    cy: 1.797,
    r: 1.797,
    transform: "translate(166.005 225.256)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_812",
    "data-name": "Ellipse 812",
    cx: 1.797,
    cy: 1.797,
    r: 1.797,
    transform: "translate(221.035 229.582)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15548",
    "data-name": "Path 15548",
    d: "M386.12,576.185a4.726,4.726,0,0,1-.149-7.246l-6.288-15.575,8.555,1.728,4.66,14.525a4.752,4.752,0,0,1-6.778,6.568Z",
    transform: "translate(-304.159 -342.675)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15549",
    "data-name": "Path 15549",
    d: "M376.789,513.424a2.119,2.119,0,0,1-2.151-1.41l-10.18-29.009-2.175-28.941a6.025,6.025,0,1,1,12.027-.729l1.217,26.43,7.989,29.244a2.126,2.126,0,0,1-1.323,2.547l-4.843,1.745A2.125,2.125,0,0,1,376.789,513.424Z",
    transform: "translate(-294.931 -286.661)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15550",
    "data-name": "Path 15550",
    d: "M782.59,509.5a2.157,2.157,0,0,1-.525-.327L772.6,501.2a2.15,2.15,0,0,1-.138-3.162l8.59-8.626a2.14,2.14,0,0,1,2.787-.222l6.5,4.717a2.152,2.152,0,0,1,.681,2.659l-5.62,11.883a2.153,2.153,0,0,1-2.805,1.053Z",
    transform: "translate(-511.992 -308.445)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15551",
    "data-name": "Path 15551",
    d: "M638.176,643.14l-5.654,1.538L623.9,623.6l8.345-2.27Z",
    transform: "translate(-330.655 -329.295)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15552",
    "data-name": "Path 15552",
    d: "M7,0H18.415V7.115H0V7A7,7,0,0,1,7,0Z",
    transform: "translate(290.524 316.733) rotate(-15.221)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15553",
    "data-name": "Path 15553",
    d: "M541.691,651.424h-5.859l-2.788-22.6h8.648Z",
    transform: "translate(-282.504 -333.265)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15554",
    "data-name": "Path 15554",
    d: "M521.93,673.346h11.418v7.115H514.933v-.118A7,7,0,0,1,521.93,673.346Z",
    transform: "translate(-272.906 -356.861)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_813",
    "data-name": "Ellipse 813",
    cx: 11.739,
    cy: 11.739,
    r: 11.739,
    transform: "translate(256.275 145.46)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15555",
    "data-name": "Path 15555",
    d: "M756.961,645.876h-8.007a2.157,2.157,0,0,1-2.149-2.018c-2.386-37.93-.99-65.138,4.392-85.624a2.234,2.234,0,0,1,.087-.264l.429-1.072a2.141,2.141,0,0,1,2-1.352h16.466a2.148,2.148,0,0,1,1.633.751l2.236,2.61c.044.051.084.1.124.157,10.085,14.064,19.123,41.559,29.59,78.515a2.143,2.143,0,0,1-1.414,2.637l-8.605,2.754a2.162,2.162,0,0,1-2.593-1.115l-22.331-46.316a1.673,1.673,0,0,0-3.164.5l-6.561,47.978A2.159,2.159,0,0,1,756.961,645.876Z",
    transform: "translate(-498.132 -343.831)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15556",
    "data-name": "Path 15556",
    d: "M778.53,514.085h-.068l-20-.631a2.144,2.144,0,0,1-2.069-1.89c-2.535-20.523,4.418-26.022,7.525-27.432a1.653,1.653,0,0,0,.962-1.311l.269-2.151a2.144,2.144,0,0,1,.425-1.045,24.578,24.578,0,0,1,15.056-8.975,2.148,2.148,0,0,1,2.51,1.84l.4,3.089a1.7,1.7,0,0,0,.341.808c10.161,13.283-1.159,32.9-3.531,36.692h0A2.155,2.155,0,0,1,778.53,514.085Z",
    transform: "translate(-503.52 -298.819)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15557",
    "data-name": "Path 15557",
    d: "M814.505,408.587a48.671,48.671,0,0,1-1.924-8.109,5.492,5.492,0,0,1,1.449-4.433c2.184-2.07,5.9-1.084,8.18.875,3.3,2.831,4.948,7.181,5.57,11.485s.349,8.681.5,13.027.771,8.815,2.987,12.557,6.328,6.614,10.665,6.3a7.506,7.506,0,0,0,4.7-1.991,5.448,5.448,0,0,0,1.636-4.731c2.217,3.969,1.093,9.349-2.214,12.47a13.211,13.211,0,0,1-12.74,2.67,17.607,17.607,0,0,1-10.062-8.686,26.667,26.667,0,0,1-2.807-13.194c.087-3.49.68-7.009.091-10.45s-2.743-6.935-6.14-7.746Z",
    transform: "translate(-533.576 -258.689)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15558",
    "data-name": "Path 15558",
    d: "M773.749,419.506a4.344,4.344,0,0,1-4.786,2.8,5.612,5.612,0,0,1-4.236-3.894,8.016,8.016,0,0,1,.626-5.877,9.152,9.152,0,0,1,5.236-4.664,7.514,7.514,0,0,1,6.833,1.092,2.513,2.513,0,0,1,1.756-1.836,4.8,4.8,0,0,1,2.635.039,10.857,10.857,0,0,1,6.043,4.4,17.668,17.668,0,0,1,2.738,7.06c.674,3.785.426,7.92-1.7,11.123s-6.474,5.094-10,3.567a4.661,4.661,0,0,1,.9-3.231,9.854,9.854,0,0,0,1.549-3.046,2.459,2.459,0,0,0-1.3-2.862c-.926-.313-1.913.194-2.889.255a3.166,3.166,0,0,1-3.037-4.562Z",
    transform: "translate(-508.07 -265.084)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15559",
    "data-name": "Path 15559",
    d: "M711.488,529.269a5.031,5.031,0,0,1,.537.582l23.631-1.839,2.492-5.191,8.326,2.737-4.5,12.312-29.767-2a5.016,5.016,0,1,1-.716-6.6Z",
    transform: "translate(-475.56 -326.487)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15560",
    "data-name": "Path 15560",
    d: "M781.552,522.917a2.153,2.153,0,0,1-.564-.253l-10.465-6.61a2.15,2.15,0,0,1-.568-3.114l7.335-9.716a2.14,2.14,0,0,1,2.731-.6l7.079,3.788a2.152,2.152,0,0,1,1.037,2.542l-3.948,12.538a2.153,2.153,0,0,1-2.636,1.425Z",
    transform: "translate(-510.766 -315.647)",
    fill: "#ca353b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeimg1);
export default __webpack_public_path__ + "static/media/welcomeimg1.9351a017b594cc87fce5a361f54845a0.svg";
export { ForwardRef as ReactComponent };